import { createEntityAdapter } from '@reduxjs/toolkit';
import { DialogMemberViewModel } from '@common/model/dialog/dialogMemberViewModel';
import { generateDialogMemberId } from '../../lib/generateDialogMemberId';

export const membersAdapter = createEntityAdapter<DialogMemberViewModel>({
  selectId: generateDialogMemberId,
});
